import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchResearchDevelopment } from '@apis/fundamentals';
import type { ResearchDevelopmentApiData } from '@app-types/performanceTrendsApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the Research/Development section
 * (GET /api/fundamentals/research-development). Reads ticker/mkt from the
 * router location so URL changes refetch; stays disabled until a token exists.
 */
export const useResearchDevelopment = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<ResearchDevelopmentApiData>({
    queryKey: ['fundamentals', 'research-development', ticker, mkt],
    queryFn: () => fetchResearchDevelopment({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
